import React from "react";

import styles from "./TablePaymentStatus.module.scss";

import { ReactComponent as TickIcon } from "../assets/tick.svg";
import { ReactComponent as CrossIcon } from "../assets/cross.svg";
import TooltipWrapper from "./tooltip/TooltipWrapper";

type Props = {
  type: "successed" | "refunded" | "uncaptured";
};

function TablePaymentStatus({ type }: Props) {
  function getStyle() {
    if (type === "successed") {
      return `${styles.paymentStatus} ${styles.success}`;
    } else if (type === "refunded") {
      return `${styles.paymentStatus} ${styles.refund}`;
    }
  }

  return (
    <TooltipWrapper
      tooltipText={`This payment is ${
        type === "successed" ? "successful" : "unsuccessful"
      }.`}
      type="top"
    >
      <div className={getStyle()}>
        <div className={styles.text}>{type}</div>
        {type === "successed" ? <TickIcon /> : <CrossIcon />}
      </div>
    </TooltipWrapper>
  );
}

export default TablePaymentStatus;
